import type { DataTableProviderFilterItem } from '@/components/common/DataTableProvider/types';

export const AKONI_ACCOUNT_STATUS_FILTER_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Onboarded', label: 'Onboarded' },
  { value: 'Pending', label: 'Pending' }
] as const;

export const AKONI_ACCOUNT_TYPE_FILTER_OPTIONS = [
  { value: 'Business', label: 'Business' },
  { value: 'Individual', label: 'Individual' },
  { value: 'Corporate', label: 'Corporate' }
] as const;

export const AKONI_BOOLEAN_FILTER_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' }
] as const;

function booleanFilter(
  label: string,
  filterKey: string
): DataTableProviderFilterItem {
  return {
    label,
    filterKey,
    type: 'select',
    placeholder: 'Any',
    selectOptions: [...AKONI_BOOLEAN_FILTER_OPTIONS]
  };
}

/** Base customer drawer filters without API-backed autocomplete (safe for api-client imports). */
export const SAVINGS_CUSTOMERS_BASE_FILTERS_LIST: DataTableProviderFilterItem[] = [
  {
    label: 'Status',
    filterKey: 'status',
    type: 'select',
    placeholder: 'All statuses',
    selectOptions: [...AKONI_ACCOUNT_STATUS_FILTER_OPTIONS]
  },
  {
    label: 'Type',
    filterKey: 'type',
    type: 'select',
    placeholder: 'All types',
    selectOptions: [...AKONI_ACCOUNT_TYPE_FILTER_OPTIONS]
  },
  booleanFilter('Onboarded', 'is_onboarded'),
  booleanFilter('PEP', 'is_pep'),
  booleanFilter('Vulnerable', 'is_vulnerable'),
  booleanFilter('Deceased', 'is_deceased'),
  booleanFilter('Has active deposits', 'has_active_deposits')
];

export function resolveAkoniAccountSearchFilters(
  searchTerm?: string
): Record<string, string> {
  const term = searchTerm?.trim();
  if (!term) return {};

  return { search: term };
}

export function mergeAkoniAccountSearchFilters(
  filters: Record<string, unknown> | undefined,
  searchTerm?: string
): Record<string, unknown> {
  const searchFilters = resolveAkoniAccountSearchFilters(searchTerm);
  return { ...searchFilters, ...(filters ?? {}) };
}
